module.exports = __webpack_public_path__ + "static/media/google.9eb18746.png";